import { Employee, FilterState } from '../types';
import { getProbationPeriodFromHiring } from '../probationPeriod';
import { hasAbsencesInMonth } from './absences';
import { sortEmployeesByName } from './employeeSort';

export interface FilterBoardParams {
  items: Record<string, Employee[]>;
  columns: { id: string; title: string; color?: string }[];
  search: string;
  filters: FilterState;
  todayStr: string;
  referenceDate: Date;
}

/**
 * Filtra colaboradores por busca textual e filtros ativos — lógica pura extraída do hook.
 * @param params - Estado do board e data de referência para probation/aniversário
 * @returns Items filtrados por coluna, ordenados por nome
 */
export function filterBoardEmployees({
  items,
  columns,
  search,
  filters,
  todayStr,
  referenceDate,
}: FilterBoardParams): Record<string, Employee[]> {
  const lowerSearch = search.toLowerCase();
  const result: Record<string, Employee[]> = {};

  const hasSearch = search.length > 0;
  const activeFilterCount = Object.values(filters).filter(Boolean).length;
  const hasFilters = activeFilterCount > 0;

  const { probation45, probation90, hasAbsences, isBirthday } = filters;

  columns.forEach((col) => {
    const colItems = items[col.id] || [];

    if (!hasSearch && !hasFilters) {
      result[col.id] = sortEmployeesByName(colItems);
      return;
    }

    result[col.id] = sortEmployeesByName(
      colItems.filter((emp) => {
        if (hasSearch) {
          const nameMatch = emp.name.toLowerCase().includes(lowerSearch);
          const roleMatch = emp.role.toLowerCase().includes(lowerSearch);
          if (!nameMatch && !roleMatch) return false;
        }

        if (hasFilters) {
          let matchesFilters = false;
          const probation = getProbationPeriodFromHiring(emp.hiringDate, referenceDate);
          if (probation45 && probation === '45') matchesFilters = true;
          else if (probation90 && probation === '90') matchesFilters = true;
          else if (hasAbsences && hasAbsencesInMonth(emp, referenceDate)) matchesFilters = true;
          else if (isBirthday && emp.birthDate && emp.birthDate.substring(5) === todayStr) {
            matchesFilters = true;
          }

          if (!matchesFilters) return false;
        }

        return true;
      }),
    );
  });

  return result;
}
